import file from './file';
import template from './template';
import importDataExcel from './importDataExcel';
import importData from './importData';
import importDataEdit from './importDataEdit';

export default {
    file,
    template,
    importDataExcel,
    importData,
    importDataEdit
}